module.exports = {
      id: "login-google-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#login-google",
      toString: function () {
        return this.url;
      }
    }